import script from "./ServerOverviewTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ServerOverviewTab.vue?vue&type=script&setup=true&lang=js"

import "./ServerOverviewTab.vue?vue&type=style&index=0&id=a63baef4&lang=scss"

const __exports__ = script;

export default __exports__